function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.9865 5.64453H9.89145C9.33167 5.64453 8.87793 6.09833 8.87793 6.65805V12.9936H18.1086C18.6374 12.9936 19.0675 13.4237 19.0675 13.9524V17.9422H26.9865C27.5463 17.9422 28 17.4884 28 16.9286V6.65805C28 6.09833 27.5462 5.64453 26.9865 5.64453Z",
    fill: "#E1D3CE",
    style: {
      fill: "#E1D3CE",
      fill: "color(display-p3 0.8824 0.8275 0.8078)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9777 8.21069C11.2419 8.21069 11.499 8.24087 11.7466 8.29627V6.65805C11.7466 6.09827 12.2004 5.64453 12.7601 5.64453H9.89145C9.33167 5.64453 8.87793 6.09833 8.87793 6.65805V8.9085C9.4633 8.47029 10.1902 8.21069 10.9777 8.21069Z",
    fill: "#CDBFBA",
    style: {
      fill: "#CDBFBA",
      fill: "color(display-p3 0.8039 0.7490 0.7294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.315 8.88782V9.56365C26.315 9.71978 26.188 9.84682 26.0319 9.84682H23.4642C23.3081 9.84682 23.1811 9.71983 23.1811 9.56365V8.88782H12.9512C13.7767 9.46537 14.3385 10.394 14.4187 11.4555H27.9996V8.88782H26.315Z",
    fill: "#9857BD",
    style: {
      fill: "#9857BD",
      fill: "color(display-p3 0.5961 0.3412 0.7412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.2255 14.2716H21.0938C20.8672 14.2716 20.6836 14.088 20.6836 13.8615C20.6836 13.6349 20.8672 13.4513 21.0938 13.4513H26.2255C26.452 13.4513 26.6357 13.6349 26.6357 13.8615C26.6357 14.088 26.452 14.2716 26.2255 14.2716Z",
    fill: "#9857BD",
    style: {
      fill: "#9857BD",
      fill: "color(display-p3 0.5961 0.3412 0.7412)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.2251 15.9198H22.4482C22.2217 15.9198 22.0381 15.7362 22.0381 15.5096C22.0381 15.2831 22.2217 15.0995 22.4482 15.0995H26.2251C26.4516 15.0995 26.6352 15.2831 26.6352 15.5096C26.6352 15.7362 26.4516 15.9198 26.2251 15.9198Z",
    fill: "#9857BD",
    style: {
      fill: "#9857BD",
      fill: "color(display-p3 0.5961 0.3412 0.7412)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.70047 7.86847C8.63739 7.86847 10.2076 6.29828 10.2076 4.36136C10.2076 2.42443 8.63739 0.854248 6.70047 0.854248C4.76355 0.854248 3.19336 2.42443 3.19336 4.36136C3.19336 6.29828 4.76355 7.86847 6.70047 7.86847Z",
    fill: "#FFE177",
    style: {
      fill: "#FFE177",
      fill: "color(display-p3 1.0000 0.8824 0.4667)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.26744 4.36136C5.26744 2.78548 6.30688 1.45247 7.73751 1.01027C7.40977 0.908936 7.06152 0.854248 6.70047 0.854248C4.76355 0.854248 3.19336 2.42444 3.19336 4.36136C3.19336 6.29828 4.76355 7.86847 6.70047 7.86847C7.06152 7.86847 7.40977 7.81378 7.73751 7.71244C6.30688 7.27024 5.26744 5.93729 5.26744 4.36136Z",
    fill: "#FFD15B",
    style: {
      fill: "#FFD15B",
      fill: "color(display-p3 1.0000 0.8196 0.3569)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.85407 2.59077L7.28693 3.46779C7.31186 3.51827 7.36004 3.55327 7.41571 3.56136L8.38357 3.70202C8.5239 3.72242 8.5799 3.89485 8.4784 3.99383L7.77807 4.6765C7.73777 4.71582 7.71934 4.77242 7.72886 4.82793L7.89418 5.79185C7.91813 5.93163 7.77146 6.03816 7.64595 5.97221L6.7803 5.5171C6.73048 5.4909 6.67093 5.4909 6.62111 5.5171L5.75546 5.97221C5.62995 6.03822 5.48328 5.93163 5.50723 5.79185L5.67255 4.82793C5.68207 4.77242 5.66369 4.71582 5.62333 4.6765L4.92295 3.99378C4.82139 3.89479 4.87745 3.72236 5.01778 3.70197L5.98564 3.56131C6.04136 3.55322 6.08954 3.51822 6.11443 3.46774L6.54728 2.59072C6.61 2.46357 6.79129 2.46357 6.85407 2.59077Z",
    fill: "#FEA95C",
    style: {
      fill: "#FEA95C",
      fill: "color(display-p3 0.9961 0.6627 0.3608)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.2661 12.9389C14.4074 12.5586 14.4849 12.1473 14.4849 11.7178C14.4849 9.78088 12.9147 8.21069 10.9778 8.21069C9.04089 8.21069 7.4707 9.78088 7.4707 11.7178C7.4707 12.1473 7.54819 12.5586 7.68951 12.9389H14.2661Z",
    fill: "#FFE177",
    style: {
      fill: "#FFE177",
      fill: "color(display-p3 1.0000 0.8824 0.4667)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.9327 8.34336C11.629 8.25756 11.309 8.21069 10.9778 8.21069C9.04089 8.21069 7.4707 9.78088 7.4707 11.7178C7.4707 12.1473 7.5482 12.5586 7.68951 12.9389H9.5993C9.45805 12.5586 9.3805 12.1473 9.3805 11.7178C9.3805 10.112 10.4601 8.75932 11.9327 8.34336Z",
    fill: "#FFD15B",
    style: {
      fill: "#FFD15B",
      fill: "color(display-p3 1.0000 0.8196 0.3569)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M9.9006 12.033C9.9409 12.0723 9.95933 12.1289 9.94982 12.1844L9.82042 12.939H12.1356L12.0062 12.1844C11.9967 12.1289 12.0151 12.0723 12.0554 12.033L12.7558 11.3504C12.8573 11.2514 12.8013 11.0789 12.6609 11.0585L11.6931 10.9179C11.6374 10.9098 11.5892 10.8748 11.5643 10.8243L11.1314 9.94729C11.0687 9.82014 10.8874 9.82014 10.8246 9.94729L10.3917 10.8243C10.3668 10.8748 10.3186 10.9098 10.263 10.9179L9.2951 11.0585C9.15477 11.0789 9.09877 11.2514 9.20027 11.3504L9.9006 12.033Z",
    fill: "#FEA95C",
    style: {
      fill: "#FEA95C",
      fill: "color(display-p3 0.9961 0.6627 0.3608)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M1.01352 25.2364H18.1086C18.6683 25.2364 19.1221 24.7826 19.1221 24.2229V13.9524C19.1221 13.3926 18.6683 12.9388 18.1086 12.9388H1.01352C0.453797 12.9388 0 13.3926 0 13.9524V24.2229C0 24.7827 0.453797 25.2364 1.01352 25.2364Z",
    fill: "#05E39C",
    style: {
      fill: "#05E39C",
      fill: "color(display-p3 0.0196 0.8902 0.6118)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.84506 24.2229V13.9524C2.84506 13.3926 3.29886 12.9388 3.85859 12.9388H1.01352C0.453797 12.9388 0 13.3926 0 13.9524V24.2229C0 24.7827 0.453797 25.2364 1.01352 25.2364H3.85859C3.29886 25.2364 2.84506 24.7827 2.84506 24.2229Z",
    fill: "#0ED290",
    style: {
      fill: "#0ED290",
      fill: "color(display-p3 0.0549 0.8235 0.5647)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M5.99163 16.4272L6.82233 18.1104C6.86384 18.1946 6.94417 18.2529 7.03703 18.2664L8.89455 18.5363C9.12845 18.5703 9.2218 18.8577 9.05259 19.0227L7.70849 20.3329C7.64127 20.3984 7.61059 20.4928 7.62651 20.5852L7.94381 22.4353C7.98378 22.6682 7.73927 22.8458 7.53009 22.7358L5.86869 21.8624C5.78562 21.8187 5.68636 21.8187 5.60334 21.8624L3.94194 22.7358C3.73276 22.8458 3.48825 22.6682 3.52823 22.4353L3.84552 20.5852C3.86138 20.4928 3.8307 20.3984 3.76355 20.3329L2.41944 19.0227C2.25018 18.8577 2.34359 18.5703 2.57748 18.5363L4.435 18.2664C4.52786 18.2529 4.60814 18.1946 4.6497 18.1104L5.48041 16.4272C5.58486 16.2153 5.88706 16.2153 5.99163 16.4272Z",
    fill: "#FFE177",
    style: {
      fill: "#FFE177",
      fill: "color(display-p3 1.0000 0.8824 0.4667)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M5.39239 21.8491L5.60764 20.5943C5.68743 20.1292 5.53321 19.6546 5.1953 19.3253L4.2836 18.4366C4.24242 18.3964 4.2171 18.349 4.20523 18.2998L2.57746 18.5363C2.34356 18.5703 2.25021 18.8577 2.41941 19.0227L3.76352 20.3328C3.83073 20.3983 3.86141 20.4927 3.84555 20.5852L3.52826 22.4352C3.48828 22.6681 3.73279 22.8458 3.94197 22.7358L5.39742 21.9706C5.38747 21.933 5.38506 21.892 5.39239 21.8491Z",
    fill: "#FFD15B",
    style: {
      fill: "#FFD15B",
      fill: "color(display-p3 1.0000 0.8196 0.3569)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M2.35365 7.23915L2.8378 8.12443C2.85705 8.15965 2.88603 8.18863 2.9213 8.20794L3.80659 8.69209C3.95227 8.77177 3.95227 8.981 3.80659 9.06068L2.9213 9.54483C2.88609 9.56408 2.8571 9.59306 2.8378 9.62834L2.35365 10.5136C2.27397 10.6593 2.06473 10.6593 1.98505 10.5136L1.50091 9.62834C1.48166 9.59312 1.45267 9.56413 1.4174 9.54483L0.532117 9.06068C0.38643 8.981 0.38643 8.77177 0.532117 8.69209L1.4174 8.20794C1.45262 8.18869 1.4816 8.1597 1.50091 8.12443L1.98505 7.23915C2.06473 7.09346 2.27397 7.09346 2.35365 7.23915Z",
    fill: "#FEA95C",
    style: {
      fill: "#FEA95C",
      fill: "color(display-p3 0.9961 0.6627 0.3608)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M2.69413 9.80439L2.20998 8.91911C2.19073 8.88383 2.16175 8.8549 2.12648 8.8356L1.2412 8.35145C1.22714 8.34379 1.21489 8.33461 1.20357 8.32471L0.532117 8.69193C0.38643 8.77161 0.38643 8.98085 0.532117 9.06053L1.4174 9.54468C1.45262 9.56393 1.4816 9.59291 1.50091 9.62818L1.98505 10.5135C2.06473 10.6592 2.27397 10.6592 2.35365 10.5135L2.72088 9.84201C2.71103 9.83069 2.70184 9.81844 2.69413 9.80439Z",
    fill: "#FE9738",
    style: {
      fill: "#FE9738",
      fill: "color(display-p3 0.9961 0.5922 0.2196)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M13.3721 0.858828L13.7938 1.62987C13.8106 1.66055 13.8358 1.68581 13.8665 1.7026L14.6375 2.1243C14.7644 2.1937 14.7644 2.37591 14.6375 2.44531L13.8665 2.86701C13.8358 2.8838 13.8106 2.90906 13.7938 2.93974L13.3721 3.71078C13.3027 3.83766 13.1205 3.83766 13.0511 3.71078L12.6294 2.93974C12.6126 2.90906 12.5873 2.8838 12.5566 2.86701L11.7856 2.44531C11.6587 2.37591 11.6587 2.1937 11.7856 2.1243L12.5566 1.7026C12.5873 1.68581 12.6126 1.66055 12.6294 1.62987L13.0511 0.858828C13.1204 0.731953 13.3027 0.731953 13.3721 0.858828Z",
    fill: "#FEA95C",
    style: {
      fill: "#FEA95C",
      fill: "color(display-p3 0.9961 0.6627 0.3608)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M13.594 3.16773L13.1723 2.39669C13.1555 2.36601 13.1303 2.34075 13.0996 2.32396L12.3285 1.90226C12.3065 1.89023 12.2897 1.87399 12.2754 1.85632L11.7856 2.12418C11.6587 2.19358 11.6587 2.3758 11.7856 2.4452L12.5566 2.86689C12.5873 2.88368 12.6126 2.90889 12.6294 2.93963L13.0511 3.71067C13.1205 3.83754 13.3027 3.83754 13.3721 3.71067L13.6399 3.22089C13.6223 3.20656 13.606 3.18977 13.594 3.16773Z",
    fill: "#FE9738",
    style: {
      fill: "#FE9738",
      fill: "color(display-p3 0.9961 0.5922 0.2196)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M16.9455 22.7693H11.537C11.2259 22.7693 10.9736 22.5171 10.9736 22.2059V21.3045C10.9736 20.9933 11.2259 20.7411 11.537 20.7411H16.9455C17.2566 20.7411 17.5088 20.9933 17.5088 21.3045V22.2059C17.5088 22.5171 17.2566 22.7693 16.9455 22.7693Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M12.8892 21.8451C12.578 21.8451 12.3258 21.5929 12.3258 21.2817V20.7411H11.537C11.2259 20.7411 10.9736 20.9933 10.9736 21.3045V22.2059C10.9736 22.5171 11.2259 22.7693 11.537 22.7693H16.9455C17.2566 22.7693 17.5088 22.5171 17.5088 22.2059V21.8451H12.8892Z",
    fill: "#EAF6FF",
    style: {
      fill: "#EAF6FF",
      fill: "color(display-p3 0.9176 0.9647 1.0000)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M17.0986 19.4384H14C13.7735 19.4384 13.5898 19.2548 13.5898 19.0282C13.5898 18.8016 13.7735 18.618 14 18.618H17.0986C17.3251 18.618 17.5088 18.8016 17.5088 19.0282C17.5088 19.2548 17.3251 19.4384 17.0986 19.4384Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M23.4648 9.90146H26.0324C26.219 9.90146 26.3703 9.7502 26.3703 9.5636V7.60409C26.3703 7.4175 26.219 7.26624 26.0324 7.26624H23.4648C23.2782 7.26624 23.127 7.4175 23.127 7.60409V9.5636C23.127 9.7502 23.2782 9.90146 23.4648 9.90146Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M24.5597 9.5636V7.60409C24.5597 7.4175 24.7109 7.26624 24.8975 7.26624H23.4648C23.2782 7.26624 23.127 7.4175 23.127 7.60409V9.5636C23.127 9.7502 23.2782 9.90146 23.4648 9.90146H24.8975C24.7109 9.90146 24.5597 9.7502 24.5597 9.5636Z",
    fill: "#EAF6FF",
    style: {
      fill: "#EAF6FF",
      fill: "color(display-p3 0.9176 0.9647 1.0000)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M14.6494 15.0441C14.8759 15.0441 15.0596 14.8604 15.0596 14.6339C15.0596 14.4074 14.8759 14.2238 14.6494 14.2238C14.4229 14.2238 14.2393 14.4074 14.2393 14.6339C14.2393 14.8604 14.4229 15.0441 14.6494 15.0441Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M15.8916 15.0441C16.1181 15.0441 16.3018 14.8604 16.3018 14.6339C16.3018 14.4074 16.1181 14.2238 15.8916 14.2238C15.6651 14.2238 15.4814 14.4074 15.4814 14.6339C15.4814 14.8604 15.6651 15.0441 15.8916 15.0441Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M17.0986 15.0441C17.3252 15.0441 17.5088 14.8604 17.5088 14.6339C17.5088 14.4074 17.3252 14.2238 17.0986 14.2238C16.8721 14.2238 16.6885 14.4074 16.6885 14.6339C16.6885 14.8604 16.8721 15.0441 17.0986 15.0441Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M21.0938 15.9198C21.3203 15.9198 21.5039 15.7362 21.5039 15.5096C21.5039 15.2831 21.3203 15.0995 21.0938 15.0995C20.8672 15.0995 20.6836 15.2831 20.6836 15.5096C20.6836 15.7362 20.8672 15.9198 21.0938 15.9198Z",
    fill: "#9857BD",
    style: {
      fill: "#9857BD",
      fill: "color(display-p3 0.5961 0.3412 0.7412)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/CashIcon.bb95b6bfeacc88e6840a0ea8f783f7e1.svg";
export { ForwardRef as ReactComponent };